<template>
  <div
    v-if="pageIsView"
    class="flex min-w-[200px] grow items-center justify-center"
  >
    <scorecard-points-bar
      :categories="model.content?.categories"
      :scorecards="modelIsScorecardGroup(model) ? model.score_cards : null"
      :total="model.points || 0"
    />
  </div>
  <div v-else class="relative flex grow items-center justify-center">
    <lf-content-loader
      class="grow"
      :is-loading="
        runScorecardIds.length > 0 && runScorecardIds.includes(model.id)
      "
    >
      <div class="min-w-[200px]">
        <scorecard-results-points-bar
          v-if="!modelIsScorecardGroup(model)"
          :categories="model.results?.[0]?.categories"
          :total="model.points || 0"
          :started="!!model.results?.length"
          :manual="isManual"
          :manual-points="model.results?.[0]?.points || 0"
          :knocked-out="isKnockoutTriggered(model)"
        />
        <scorecard-results-points-bar
          v-if="modelIsScorecardGroup(model)"
          :weighted-points="model.results?.[0]?.weighted_points?.score_cards"
          :total="model.group_points || 0"
          :started="!!model.results?.length"
          :knocked-out="isGroupKnockoutTriggered(model) === true"
          is-group
        />
      </div>
    </lf-content-loader>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { SCORECARD_TYPE_MANUAL } from "@/helpers/constants";
import { modelIsScorecardGroup } from "@/helpers/scorecards";
import {
  isGroupKnockoutTriggered,
  isKnockoutTriggered,
} from "@/helpers/scorecards";
import { useScorecardsBase } from "@/hooks/scorecards";

import ScorecardPointsBar from "@/components/scorecards/ScorecardPointsBar.vue";
import ScorecardResultsPointsBar from "@/components/scorecards/ScorecardResultsPointsBar.vue";
import LfContentLoader from "@/components/ui/LfContentLoader.vue";

import type { IScorecard, IScorecardGroup } from "@/models/scorecards";

const { runScorecardIds } = useScorecardsBase();

const props = defineProps<{
  model: IScorecard | IScorecardGroup;
  pageIsView?: boolean;
}>();

const isManual = computed(() => {
  return props.model?.type === SCORECARD_TYPE_MANUAL;
});
</script>
